import * as React from 'react'
import Button from 'src/packages/button/Button'
import Code from 'src/components/Code'
import CodeBox from 'src/components/CodeBox'
import { renderString } from 'src/utils/renderCode'

class Start extends React.Component {
  public static displayName = 'Start'

  public render() {
    return (
      <div className="start">
        <section>
          <h1>开始使用</h1>
          <p className="text">
            Xue-react 已发布至 NPM，您可以使用 npm / yarn 来安装。
            <br />
            <br />
            <span style={{ fontWeight: 600 }}>$ npm install xue-react</span>
            <br />
            <span style={{ fontWeight: 600 }}>$ yarn add xue-react</span>
          </p>
        </section>
        <section>
          <h2>简单示例</h2>
        </section>
        <div className="example">
          <div className="container">
            <Button style={{ marginRight: '20px' }} type="primary">
              Primary
            </Button>
          </div>
          <CodeBox
            title="使用 Button"
            description="使用 Xue-react 按钮组件。"
            defaultVisible={true}
          >
            {renderString(`import { Button } from 'xue-react'`)}
            {renderString(`import 'xue-react/lib/xue-react.css'`)}
            <br />
            <Code
              code={`&lt;Button type="primary"&gt;Primary&lt;/Button&gt;`}
            />
          </CodeBox>
        </div>
      </div>
    )
  }
}

export default Start



// WEBPACK FOOTER //
// ./src/components/Start.tsx